import React from 'react';
import { Typography } from '@mui/material';
import { VBox, HBox } from '@/ui/shared-components/LayoutBoxes';
import theme from '@/theme';
import BenefitPageMarkdownElement from './BenefitPageMarkDownElement';


const BenefitPageExample = ({ t, idx, content }) => {
    return (
        <VBox
            sx={{
                backgroundColor: 'greyTransparent.main',
                borderTop: `1px solid ${theme.palette.grey.light}`,
                borderRadius: theme.shape.borderRadius,
                boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.25)',
                padding: 2,
                gap: 2,
                flex: 1,
            }}
        >
            <VBox sx={{ gap: 2 }}>
                <HBox sx={{ justifyContent: "space-between", alignItems: "center", cursor: "pointer" }}>
                    <Typography variant="h2" sx={{ fontWeight: 400, wordBreak: "break-word", color: 'pink.main' }}>
                        {t('app.benefitPage.general.example')}{content.title ? `: ${content.title}` : ` ${idx}`}
                    </Typography>

                </HBox>
                <VBox sx={{ maxWidth: 800 }}>
                    <BenefitPageMarkdownElement content={content?.description} />
                </VBox>
            </VBox>
        </VBox>
    )
}

export default BenefitPageExample;